import { Box, Grid } from "@mui/material";
import './style.scss';
import Facebook from '../../assets/images/facebook.svg';
import Zalo from '../../assets/images/zalo.svg';
import Youtube from '../../assets/images/youtube.svg';
import Logo from '../../assets/images/sublogo-mobile.svg';

const sections = [{
  title: 'Về chúng tôi',
  links: [
    { text: 'Về Manulife', url: 'https://www.manulife.com.vn/vi/ve-chung-toi/ve-manulife.html' },
    { text: 'Thông cáo báo chí', url: 'https://www.manulife.com.vn/vi/ve-chung-toi/tin-tuc-va-su-kien/thong-cao-bao-chi.html' },
    { text: 'Kênh hợp tác qua Ngân hàng', url: 'https://www.manulife.com.vn/vi/ve-chung-toi/kenh-hop-tac-qua-ngan-hang.html' },
    { text: 'Công ty TNHH Quản lý Quỹ Manulife Investment (Việt Nam)', url: 'https://www.manulife.com.vn/vi/ve-chung-toi/cong-ty-quan-ly-quy-manulife-viet-nam.html' },
    { text: 'Liên hệ với Manulife Việt Nam', url: 'https://www.manulife.com.vn/vi/lien-he.html' }
  ]
}, {
  title: 'SẢN PHẨM CHÍNH',
  links: [
    { text: 'Bảo Hiểm Nhân Thọ', url: 'https://www.manulife.com.vn/vi/san-pham-bao-hiem/bao-hiem-nhan-tho/bao-hiem-nhan-tho-manulife-moi-nhat.html' },
    { text: 'Bảo Hiểm Sức Khỏe', url: 'https://www.manulife.com.vn/vi/san-pham-bao-hiem/bao-hiem-suc-khoe/bao-hiem-suc-khoe-manulife-moi-nhat.html' },
    { text: 'Bảo hiểm Liên Kết Đầu Tư', url: 'https://www.manulife.com.vn/vi/san-pham-bao-hiem/bao-hiem-lien-ket-dau-tu/bao-hiem-lien-ket-don-vi.html' },
    { text: 'Sản Phẩm Đầu Tư', url: 'https://www.manulife.com.vn/vi/san-pham-bao-hiem/san-pham-dau-tu-moi-nhat/quy-mo-manulife.html' }
  ]
}, {
  title: 'LIÊN KẾT NHANH',
  links: [
    { text: 'Trang Hợp đồng của tôi Manulife Vietnam', url: 'https://hopdongcuatoi.manulife.com.vn/?_ga=2.121247880.1475551268.1755758176-1104490906.1731582624' },
    { text: 'eClaims', url: 'https://boithuongbaohiem.manulife.com.vn/' },
    { text: 'Đóng phí trực tuyến', url: 'https://dongphi.manulife.com.vn/' }
  ]
}, {
  title: 'MỤC TIÊU CỦA BẠN',
  links: [
    { text: 'Làm chủ tương lai', url: 'https://www.manulife.com.vn/vi/nhu-cau/lam-chu-tuong-lai.html' },
    { text: 'Bảo toàn sức khỏe', url: 'https://www.manulife.com.vn/vi/nhu-cau/bao-toan-suc-khoe.html' },
    { text: 'Bảo vệ cả nhà, an tâm vui sống', url: 'https://www.manulife.com.vn/vi/nhu-cau/bao-ve-ca-nha-an-tam-vui-song.html' },
    { text: 'Nghỉ hưu an nhàn', url: 'https://www.manulife.com.vn/vi/nhu-cau/nghi-huu-an-nhan.html' }
  ]
}];

const terms = [{
  text: 'Điều khoản sử dụng',
  url: 'https://www.manulife.com.vn/vi/manulife-vietnam/dieu-khoan-su-dung.html'
}, {
  text: 'Chính sách bảo mật dữ liệu cá nhân',
  url: 'https://www.manulife.com.vn/vi/manulife-vietnam/chinh-sach-bao-mat-du-lieu-ca-nhan.html'
}, {
  text: 'Chính sách Cookies',
  url: 'https://www.manulife.com.vn/vi/manulife-vietnam/chinh-sach-cookies.html'
}];

const socials = [{
  name: 'Facebook',
  url: 'https://www.facebook.com/ManulifeVietnam',
  icon: Facebook
}, {
  name: 'YouTube',
  url: 'https://www.youtube.com/@Manulifevietnam',
  icon: Youtube
}, {
  name: 'Zalo',
  url: 'https://zalo.me/3305978929914720825',
  icon: Zalo
}];

function Terms() {
  return (
    <Grid container spacing={2} className="footer-terms">
      <Grid size={{ sm: 6, xs: 12}} className="footer-terms-links">
        {terms.map((term, index) => (
          <a key={index} href={term.url}>{term.text}</a>
        ))}
      </Grid>
      <Grid size={{ sm: 6, xs: 12}} className="footer-social">
        <Box display="flex" alignItems="center">
          {socials.map((social, index) => (
            <div key={index} className="social-link">
              <a href={social.url} aria-label={social.name}><img src={social.icon} alt={social.name} /></a>
            </div>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}

function Copyright() {
  return (
    <Grid container spacing={2} className="footer-copyright">
      <Grid size={{ md: 3, sm: 6, xs: 12}}>
      <img src={Logo} alt="Manulife Logo" />
      </Grid>
      <Grid size={{ md: 9, sm: 6, xs: 12}}>
        <p>© Bản quyền thuộc về Công ty TNHH Manulife (Việt Nam).
          <br />
          Giấy phép số 503/GP-BC do Bộ VHTT cấp ngày 15/11/2004.
          <br />
          Văn phòng chính: Tòa nhà Manulife Plaza, 75 Hoàng Văn Thái, Phường Tân Mỹ, Tp. HCM<br />
          Đường dây nóng:&nbsp;<a href="tel:19001776" target="_blank">1900 1776</a>
        </p>
      </Grid>
    </Grid>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <Grid container spacing={2} className="footer-section">
            {sections.map((section, index) => (
              <Grid key={index} size={{ md: 3, sm: 6, xs: 12 }}>
                <p className="footer-title">{section.title}</p>
                <ul className="footer-links">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.url}>{link.text}</a>
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
          </Grid>
          <Box className="line"></Box>
          <Terms />
          <Box className="line"></Box>
          <Copyright />
        </div>
      </div>
    </footer>
  );
}